declare global {
	interface Window {
		dataLayer?: unknown[];
	}
}

export type GenerateLeadFormId = "contact" | "inquiry";

export function pushGenerateLeadEvent(formId: GenerateLeadFormId): void {
	window.dataLayer ??= [];
	window.dataLayer.push({
		event: "generate_lead",
		form_id: formId,
		form_destination: location.href,
	});
}
